<template>
  <div>
    <div class="schedule-edit-weekdays btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
      <label v-for="i in range(0,7)" class="btn btn-outline-secondary text-capitalize" :class="{active: schedule.days.indexOf(i) !== -1}">
        <input type="checkbox" autocomplete="off" v-model="schedule.days" :value="i">
        {{ weekdayLabel(i) }}
      </label>
    </div>

    <ul class="schedule-edit-shortcuts list-inline">
      <li class="list-inline-item" @click="schedule.days = range(0,0)">никогда</li>
      <li class="list-inline-item" @click="schedule.days = range(0,5)">будни</li>
      <li class="list-inline-item" @click="schedule.days = range(5,7)">выходные</li>
      <li class="list-inline-item" @click="schedule.days = range(0,7)">ежедневно</li>
    </ul>

    <div v-if="schedule.days.length > 0" class="schedule-edit-form form-inline align-items-baseline">
      С
      <select v-model="schedule.from" class="custom-select mx-2">
        <option v-for="i in range(0,24)" :value="formatHour(i)">{{ formatHour(i) }}</option>
      </select>
      по
      <select v-model="schedule.till" class="custom-select mx-2">
        <option v-for="i in range(0,24)" :value="formatHour(i)">{{ formatHour(i) }}</option>
      </select>
      каждые
      <select v-model="interval" class="custom-select mx-2">
        <option v-for="i in intervals" :value="i">{{ formatInterval(i) }}</option>
      </select>
    </div>

    <template v-if="schedule && schedule.days && schedule.days.length > 0" class="card-body">
    <hr>
    <h5>Отчеты будут отправляться в</h5>
    <ul class="list-inline m-0" v-for="i in schedule.days">
      <li class="list-inline-item text-capitalize font-weight-bold">{{ i | weekdayLabel }}</li>
      <li class="list-inline-item" v-for="time in reportTimes">{{ time }}</li>
    </ul>
  </template>
  </div>

</template>

<script>
  import moment from 'moment'
  import {assign, range, isEqual, pick, omit} from 'lodash'

  export default {
    props: ['value', 'withMinutes'],
    data () {
      console.log(omit(this.value, ['every', 'every_unit']))
      return {
        interval: assign({
          every: 1,
          every_unit: 'hour',
        }, pick(this.value, ['every', 'every_unit'])),
        schedule: assign({
          days: [],
          from: '23:00',
          till: '23:00',
        }, omit(this.value, ['every', 'every_unit'])),
        oldVal: null,
      }
    },
    methods: {
      range,
      weekdayLabel (i) {
        return moment().weekday(i).format('dd')
      },
      formatHour (hour) {
        hour = parseInt(hour)
        return (hour < 10 ? `0${hour}` : `${hour}`) + ':00'
      },
      formatInterval (interval) {
        const labels = {
          hour: 'ч',
          minute: 'мин',
        }
        return `${interval.every} ${labels[interval.every_unit]}`
      },
    },
    watch: {
      preparedSchedule: {
        handler () {
          if (isEqual(this.preparedSchedule, this.oldVal)) return
          this.preparedSchedule.days.sort()
          this.$emit('input', this.preparedSchedule)
          this.oldVal = this.preparedSchedule
        },
        deep: true,
      },
    },
    computed: {
      preparedSchedule () {
        return assign({}, this.schedule, this.interval)
      },
      intervals () {
        let intervals = range(1, 13).map((hour) => ({
          every: hour,
          every_unit: 'hour',
        }))

        if (this.withMinutes) {
          const intervalsMinutes = [10, 15, 20, 30].map((minute) => ({
            every: minute,
            every_unit: 'minute',
          }))
          intervals = intervalsMinutes.concat(intervals)
        }

        return intervals
      },
      reportTimes () {
        if (!(this.preparedSchedule && this.preparedSchedule.from && this.preparedSchedule.till && this.preparedSchedule.every)) return []
        const fromTime = moment(this.preparedSchedule.from, 'HH:mm')
        const tillTime = moment(this.preparedSchedule.till, 'HH:mm')
        const times = []
        while (fromTime.isSameOrBefore(tillTime)) {
          times.push(fromTime.format('HH:mm'))
          fromTime.add(this.preparedSchedule.every, this.preparedSchedule.every_unit)
        }
        return times
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .schedule-edit-shortcuts {
    > .list-inline-item {
      color: $link-color;
      border-bottom: 1px dotted $link-color;
      cursor: pointer;
    }
  }
  .schedule-edit-form {
    .custom-select {
      width: 7em;
    }
  }
  .schedule-edit-preview {
    background-color: $gray-lightest;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/schedule/editor.vue